module.exports = __webpack_public_path__ + "static/media/ps_modal_wire_black.77726abb.svg";